module.exports = __webpack_public_path__ + "static/media/video.86d53dd.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/medio-ambiente/video.mp4
// module id = LzmR
// module chunks = 0